import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { accessIdSelector } from 'modules/Login/selectors/user'
import Dialog from '@material-ui/core/Dialog'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import Close from '@material-ui/icons/Close'
import { IconButton, Box, makeStyles } from '@material-ui/core'
import Checkout from './components/Checkout'
import { CREATE_FINANCIAL, GET_FINANCIAL_AGREEMENT_PENDING, PAYMENT_CREDIT_NEGOTIATION } from '../constants'
import { apiResetAction } from 'utils/API/actions'
import { isLoadingPostFinancialSelector } from '../selectors/postFinancial'
import { fetchExpirated, resetTourModalPayment } from '../actions'
import { hide } from 'layouts/actions'
import { isEmpty, isNil } from 'ramda'
import { stepTourPaymentSelector } from '../selectors/payment'

const useStyles = makeStyles(() => ({
  paperScrollPaper: {
    maxHeight: '98%',
  },
  buttonClose: {
    position: 'absolute',
    right: 0
  }
}))

export const stepsBillet = [
  {
    label: 'Pagamento',
    id: 'lbl-mdl-neg-pag'
  },
  {
    label: 'Aceite',
    isConfirmar: true,
    isAccept: true,
    isVoltar: true,
    labelButton: 'Finalizar acordo',
    id: 'lbl-mdl-neg-cfm'
  },
  { 
    label: 'Impressão',
    isFechar: true,
    isSmallModal: true,
    id: 'lbl-mdl-pag-cfm'
  }]

export const stepsCard = [
  {
    label: 'Proposta',
    isConfirmar: true,
    labelButton: 'Avançar',
    id: 'lbl-mdl-neg-cfm'
  },
  {
    label: 'Pagamento',
    id: 'lbl-mdl-neg-pag',
    labelButton: 'Finalizar acordo',
    // isAccept: true,
    // isVoltar: false,
    // isConfirmar: true
  },
  // {
  //   label: 'Aceite',
  //   labelButton: 'Finalizar acordo',
  //   isAccept: true,
  //   isVoltar: false,
  //   isConfirmar: true,
  //   id: 'lbl-mdl-neg-cfm'
  // },
  { 
    label: 'Confirmação',
    isFechar: true,
    isSmallModal: true,
    id: 'lbl-mdl-pag-cfm'
  }
]

export const Modal = ({ open, onClose, isBillet, data }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const theme = useTheme()
  const [activeStep, setActiveStep] = useState(0)
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const isLoadingFinance = useSelector(isLoadingPostFinancialSelector)
  const accessId = useSelector(accessIdSelector)
  const activeStepTour = useSelector(stepTourPaymentSelector)

  useEffect(() => {
    if (!isNil(activeStepTour)) {
      setActiveStep(activeStepTour)
    }
  }, [activeStepTour])

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return
    onClose()
    dispatch(hide())
    setActiveStep(0)
    dispatch(apiResetAction(PAYMENT_CREDIT_NEGOTIATION))
    dispatch(apiResetAction(CREATE_FINANCIAL))
    dispatch(apiResetAction(GET_FINANCIAL_AGREEMENT_PENDING))
    dispatch(resetTourModalPayment())
    dispatch(fetchExpirated({ accessId }))
  }

  const getItems = () => {
    const itemsSelected = data && data.filter(item => item.tableData && item.tableData.checked)
    return isBillet ? data : (itemsSelected && itemsSelected.length > 0 && itemsSelected) || data || []
  }

  if (isEmpty(getItems())) {
    return null
  }

  return (
    <Dialog
      maxWidth={(activeStep === 0 && 'xs') || 'sm'}
      fullScreen={fullScreen}
      open={open && !isEmpty(data)}
      onClose={handleClose}
      aria-labelledby='payment-dialog-title'
      classes={{ paper: !fullScreen && classes.paperScrollPaper }}
    >
      <Box display='flex' justifyContent='flex-end'>
        <IconButton className={classNames(!fullScreen && classes.buttonClose)} disabled={isLoadingFinance} aria-label='close-payment' id='ico-mdl-pag-fch' onClick={handleClose} >
          <Close />
        </IconButton>
      </Box>
      <Checkout 
        isBillet={isBillet}
        handleClose={handleClose}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        items={getItems()}
        steps={isBillet ? stepsBillet : stepsCard}
      />
    </Dialog>
  )
}

export default Modal;